import {
    addComponent,
    defineQuery,
    enterQuery,
    exitQuery,
    removeComponent,
} from "bitecs";
import { MovementGoalComponent } from "../components/MovementGoalComponent";
import { PositionComponent } from "../components/PositionComponent";
import { TagWanderComponent } from "../components/TagWanderComponent";
import { TinyPetsWorld } from "../TinyPetsWorld";

export const createWanderSystem = (
    world: TinyPetsWorld,
    config: {}
): {
    wanderSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const query = defineQuery([TagWanderComponent, PositionComponent]);
    const enteredQuery = enterQuery(query);
    const exitedQuery = exitQuery(query);

    const arrivedQuery = defineQuery([MovementGoalComponent]);
    const noMoreGoalQuery = exitQuery(
        defineQuery([MovementGoalComponent, PositionComponent])
    );

    const addNextGoal = (eid: number) => {
        addComponent(world, MovementGoalComponent, eid);

        const minX = -10;
        const maxX = 3;
        const minZ = -10;
        const maxZ = -3;

        MovementGoalComponent.x[eid] = minX + Math.random() * (maxX - minX);
        MovementGoalComponent.y[eid] = PositionComponent.y[eid];
        MovementGoalComponent.z[eid] = minZ + Math.random() * (maxZ - minZ);
    };

    const removeNextGoal = (eid: number) => {
        removeComponent(world, MovementGoalComponent, eid);
    };

    const updateIfArrived = (eid: number) => {
        const delta =
            Math.abs(MovementGoalComponent.x[eid] - PositionComponent.x[eid]) +
            Math.abs(MovementGoalComponent.y[eid] - PositionComponent.y[eid]) +
            Math.abs(MovementGoalComponent.z[eid] - PositionComponent.z[eid]);

        if (delta <= 1) {
            addNextGoal(eid);
        }
    };

    return {
        wanderSystem: (world: TinyPetsWorld) => {
            arrivedQuery(world).forEach(updateIfArrived);

            enteredQuery(world).forEach(addNextGoal);
            noMoreGoalQuery(world).forEach(addNextGoal);

            exitedQuery(world).forEach(removeNextGoal);

            return world;
        },
    };
};
